<app-header 
  [userName]="userName" 
  (logout)="logout()" 
  (redirectToHomePage)="redirectToHomePage()">
  <ng-container id="left-content">
    <button
      pButton
      aria-label="menu"
      type="button"
      class="p-button-text"
      data-test-id="menu-icon"
      [icon]="'pi pi-bars'">
    </button>
  </ng-container>
</app-header>

<main>
  <router-outlet></router-outlet>
</main>
